<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'AGN' && !hideBrand">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['AGT']}}
                                                <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ISOC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['CI']}}
                                                <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['U']}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'GI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['G']}}
                                                <i @click="setSortTable('GI')" :class="setSortLogo('GI')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'EI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['EI']}}
                                            </template>
                                            <template v-else-if="header == 'TI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['BI']}}
                                                <i @click="setSortTable('TI')" :class="setSortLogo('TI')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['BT']}}
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BCBA' && repoerIsCrypto">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['CYT']['BCBA']}}
                                            </template>
                                            <template v-else-if="header == 'BCWLA' && repoerIsCrypto">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['CYT']['BCWLA']}}
                                            </template>
                                            <template v-else-if="header == 'BB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BETRPT']['BB']}}
                                                <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['BA']}}
                                                <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'WLA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['WL']}}
                                                <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BD'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['BD']}}
                                            </template>
                                            <template v-else-if="header == 'MIP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['IP']}}
                                                <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('ABRBM', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['ABRBM']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="!hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :limit="1"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :disable-branch-nodes="false"
                                                  :limitText="count => `+${count}`"
                                                  :load-options="loadAgentOptions"
                                                  :options="ddAgentList"
                                                  :defaultExpandLevel="Infinity"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="searchAgent" />
                            </div>

                            <!--Game Start Date (GMT+08)-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['SPT']['GSD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   :opens="!hideBrand ? 'center' : 'right'"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <!--Game End Date (GMT+08)-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['SPT']['GED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <!--UserID-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                            :options="ddMemberList"
                                            :cacheOptions="false"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="searchUserId" />
                            </div>
                            <!--Sport Type-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["SPT"]["ST"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddSportType"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['SPT']['SST']"
                                            :placeholder="this.utilGetDDLanguage('SPT.SST')"
                                            v-model="searchSportType" />
                            </div>
                            <!--League-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["SPT"]["L"]}} :</span>
                                <treeselect :key="dd_leagueKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadLeagueOptions"
                                            :options="ddLeagueList"
                                            :defaultOptions="ddDefaultLeagList"
                                            :auto-load-root-options="convertToBool(searchLeague)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['SPT']['SL']"
                                            :placeholder="this.utilGetDDLanguage('SPT.SL')"
                                            v-model="searchLeague" />
                            </div>
                            <!--Home Team-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["SPT"]["HT"]}} :</span>
                                <treeselect :key="dd_homeKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadHomeOptions"
                                            :options="ddHomeList"
                                            :defaultOptions="ddDefaultHomeList"
                                            :auto-load-root-options="convertToBool(searchHome)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['SPT']['SHT']"
                                            :placeholder="this.utilGetDDLanguage('SPT.SHT')"
                                            v-model="searchHome" />
                            </div>
                            <!--Away Team-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["SPT"]["AT"]}} :</span>
                                <treeselect :key="dd_awayKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadAwayOptions"
                                            :options="ddAwayList"
                                            :defaultOptions="ddDefaultAwayList"
                                            :auto-load-root-options="convertToBool(searchAway)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['SPT']['SAT']"
                                            :placeholder="this.utilGetDDLanguage('SPT.SAT')"
                                            v-model="searchAway" />
                            </div>


                            <!--Currency-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :load-options="loadCurrencyOptions"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrencyId" />
                            </div>
                            <!--Min Bet Amount-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["BETRPT"]["MBA"]}} :</span>
                                <CInput size="sm" :value="ThousandSeparator(searchMinAmount)" @change="v => searchMinAmount = RemoveThousandSeparator(v)" />
                            </div>
                            <!--Max Bet Amount-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["BETRPT"]["MXBA"]}} :</span>
                                <CInput size="sm" :value="ThousandSeparator(searchMaxAmount)" @change="v => searchMaxAmount = RemoveThousandSeparator(v)" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["MT"]["VDP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vdp"
                                            placeholder
                                            v-model="searchVDP" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['RSN']}} :</span>
                                <CInput size="sm"
                                        :value="searchRegisterSourceName"
                                        @change="v => searchRegisterSourceName = v"></CInput>
                            </div>
                            <!--Cash Out-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['WLRPT']['CASHOUTTICKETS']}}:</span>
                                <treeselect :multiple="false"
                                            :options="arry_cash_out"
                                            placeholder
                                            v-model="searchCashOut" />
                            </div>
                        </div>

                        <!--Search-->
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-summarywrapper'>
                <div class="custom-table-wrapper">
                    <table class='custom-table custom-tableMP afb-blue'>
                        <thead>
                            <tr>
                                <!--Bet List Summary-->
                                <th colspan="100%">
                                    <span>{{this.getLanguage["BETRPT"]["ABRBMS"]}}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_Psl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-if=" arry_Psl.length != 0" @click="bool_showSummary = !bool_showSummary" class='kema-eft'>
                            <td style="width:25%"></td>
                            <td style="width:25%">{{this.getLanguage['MTA']['GT']}}</td>
                            <td style="width:25%" :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(decimal_gt, 2, "USD") }}</td>
                            <td style="width:25%" :style="renderActivityStyle(decimal_wlagt >= 0 ? 1 : 2)" class="tableCtnRight">{{ formatNumber(decimal_wlagt, 2, "USD") }}</td>
                        </tr>
                        </tbody>
                        <thead v-if="bool_showSummary">
                            <tr>
                                <!--Currency-->
                                <th style="width:25%">{{this.getLanguage['MTA']['C']}}</th>
                                <!--Total Bet Count-->
                                <th style="width:25%" class="tableCtnRight">{{this.getLanguage['BETRPT']['TBC']}}</th>
                                <!--Total Bet Amount-->
                                <th style="width:25%" class="tableCtnRight">{{this.getLanguage['BETRPT']['TBEA']}}</th>
                                <!--Total Win Loss Amount-->
                                <th style="width:25%" class="tableCtnRight">{{this.getLanguage['WLRPT']['TWL']}}</th>
                            </tr>
                        </thead>
                        <tbody v-if="bool_showSummary">
                        <td colspan="100%" v-if=" arry_Psl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_Psl">
                            <td>{{ renderCurrency(data.ISOC) }} </td>
                            <td class="tableCtnRight">{{ data.TMC }}</td>
                            <td :style="renderActivityStyle(3)" class="tableCtnRight">{{ formatNumber(data.TBA, 2, data.CS) }}</td>
                            <td :style="renderActivityStyle(data.TWLA >= 0 ? 1 : 2)" class="tableCtnRight">{{ formatNumber(data.TWLA, 2, data.CS) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class='table-wrapper with_page'>
                <header class="table-header">
                    <!--Bet List-->
                    <strong>{{getLanguage['BETRPT']['ABRBM']}} {{ searchInfo }} </strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control" v-model="int_Page" type="number" v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'AGN' && !hideBrand">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['G']}}
                                        <i @click="setSortTable('GI')" :class="setSortLogo('GI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'EI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['EI']}}
                                    </template>
                                    <template v-else-if="header == 'TI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BI']}}
                                        <i @click="setSortTable('TI')" :class="setSortLogo('TI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BT']}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BCBA' && repoerIsCrypto">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['CYT']['BCBA']}}
                                    </template>
                                    <template v-else-if="header == 'BCWLA' && repoerIsCrypto">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['CYT']['BCWLA']}}
                                    </template>
                                    <template v-else-if="header == 'BB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BETRPT']['BB']}}
                                        <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BA']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'WLA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BD']}}
                                    </template>
                                    <template v-else-if="header == 'MIP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['IP']}}
                                        <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'AGN' && !hideBrand">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['G']}}
                                        <i @click="setSortTable('GI')" :class="setSortLogo('GI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'EI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['EI']}}
                                    </template>
                                    <template v-else-if="header == 'TI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BI']}}
                                        <i @click="setSortTable('TI')" :class="setSortLogo('TI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BT']}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BCBA' && repoerIsCrypto">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['CYT']['BCBA']}}
                                    </template>
                                    <template v-else-if="header == 'BCWLA' && repoerIsCrypto">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['CYT']['BCWLA']}}
                                    </template>
                                    <template v-else-if="header == 'BB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i> {{getLanguage['BETRPT']['BB']}}
                                        <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BA']}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'WLA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['WL']}}
                                        <i @click="setSortTable('WLA')" :class="setSortLogo('WLA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BD'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['BD']}}
                                    </template>
                                    <template v-else-if="header == 'MIP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['IP']}}
                                        <i @click="setSortTable('MIP')" :class="setSortLogo('MIP')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arr_reportList">
                            <tr :class="data.bool_showDetails? 'bd-selected kema-eft pointer':' kema-eft pointer'">
                                <td v-for="header in reportHeaders" :key="header" @click="clickList(data,index)" :class="renderClassName(header, data)">
                                    <template v-if="header == 'NO'">
                                        {{ CountItem(index+1) }}
                                    </template>
                                    <template v-else-if="header == 'AGN' && !hideBrand">
                                        <span class="grid-line">{{ data.AGN }}</span>
                                        <span class="saggroupname" v-if="data.SAGN != ''">{{ data.SAGN }}</span>
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        {{ renderCurrency(data.ISOC) }}
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <span class="grid-line" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="CheckingMember(data.AGI,data.MI)">
                                            <div class="custom-tooltip">
                                                <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                                <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.TW == 0">
                                                <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon"/>
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.HTWT">
                                                <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.RP">
                                                <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                            </div>
                                            <div class="float-right ml-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                </svg>
                                            </div>
                                        </span>
                                        <span class="grid-line" v-if="(isSENS == 1 && data.AGI != curAGI)">
                                            <div class="custom-tooltip">
                                                <span :style="getbgtooltip(data)">{{data.U}}</span>
                                                <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.TW == 0">
                                                <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon"/>
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.HTWT">
                                                <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                            </div>
                                            <div class="custom-tooltip" v-if="data.RP">
                                                <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                                <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                            </div>
                                            <div class="float-right ml-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                </svg>
                                            </div>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'GI'">
                                        <span v-if="data.PN=='AFB1188'">{{ renderSportType(data.SGT) }}</span>
                                        <span v-else>{{ getGameName(data.PN, data.GN) }}</span>
                                    </template>
                                    <template v-else-if="header == 'EI'">
                                        <a href="#" @click="searchHomeAway(data.LEAG, data.HOME, data.AWAY)">
                                            <div class="custom-tooltip">
                                                <span v-if="data.PN == 'CQ9_LOTTERY'">{{ getGameName(data.PN, data.GN) }}</span>
                                                <span v-else v-html="renderEventInfo(data.EI, data.PN)"></span>
                                                <span class="custom-tooltiptext">{{ getLanguage['SPT']['HTAT'] }}</span>
                                            </div>
                                        </a>
                                    </template>
                                    <template v-else-if="header == 'TI'">
                                        {{ data.BID }}
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <span>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}</span>
                                        <br />
                                        <span v-if="data.ASMRT != null || data.ASMRT != ''">
                                            <span v-html="data.ASMRT"></span>
                                        </span>
                                    </template>
                                    <template v-else-if="header == 'BCBA' && repoerIsCrypto">
                                        {{ data.BCBA }}
                                    </template>
                                    <template v-else-if="header == 'BCWLA' && repoerIsCrypto">
                                        {{ data.BCWLA }}
                                    </template>
                                    <template v-else-if="header == 'BB'">
                                        {{ formatNumber(data.TBB, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'BA'">
                                        {{ formatNumber(data.BA, 2, data.ISOC, false) }}
                                        <br />
                                        <span v-if="data.PN == 'AFB1188' && data.OBA!=''" v-html="data.OBA" class="oddsinfo"></span>
                                    </template>
                                    <template v-else-if="header == 'WLA'">
                                        {{ formatNumber(data.WLA, 2, data.ISOC, false) }}
                                    </template>
                                    <template v-else-if="header == 'BD'">
                                        <span v-html="renderGameResult(data.BD, data.PN)"></span>
                                    </template>
                                    <template v-else-if="header == 'MIP'">
                                        {{ data.MIP }}
                                    </template>
                                </td>
                            </tr>
                            <!-- AFB1188 Details -->
                            <template v-if="data.PN == 'AFB1188' && data.ISPAR && data.bool_showDetails">
                                <tr v-for="(cdata, cindex) in data.PBD" class="bd-bg afb1188-subitem">
                                    <td v-for="header in reportHeaders" :key="header">
                                        <template v-if="header == 'EI'">
                                            <span v-html="getGameName1188(cdata.GD)"></span>
                                        </template>
                                        <template v-else-if="header == 'BD'">
                                            <span v-html="renderGameResult(cdata.BD, data.PN)"></span>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        </tbody>
                    </table>
                </div>

                <footer style=" padding: 0.57rem 0rem;" v-if="int_TP >= 2">
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import $ from 'jquery'
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_showSearchBar: true,
                // dropdown value
                ddAgentList: null,
                ddCurrencyList: null,
                // search fields
                dd_leagueKey: 0,
                dd_homeKey: 0,
                dd_awayKey: 0,
                ddDefaultMemberList: null,
                searchRegisterSourceName:null,
                ddDefaultLeagList: null,
                ddDefaultHomeList: null,
                ddDefaultAwayList: null,
                searchAgent: null,
                searchUserId: null,
                searchUsername: null,
                searchCurrencyId: null,
                searchMinAmount: null,
                searchMaxAmount: null,
                searchSportType: null,
                searchLeague: null,
                searchHome: null,
                searchAway: null,
                searchCreatedTS: { startDate: this.getMonthStartDate(), endDate: this.getMonthEndDate() },
                arr_reportList: [],
                ddMemberList: [],
                ddLeagueList: [],
                ddHomeList: [],
                ddAwayList: [],
                ddSportType: [],
                constAccessType: constAccessType,
                bool_showSummary: true,
                arry_Psl: [],
                repoerIsCrypto: false,
                searchInfo: '',
                decimal_gt: 0,
                decimal_wlagt: 0,
                hideBrand: false,
                searchAgi: '',
                arry_vdp: [],
                arry_cash_out: [],
                searchVDP: null,
                searchCashOut: null,
                defaultReportHeaders: ['NO', 'U', 'GI', 'EI', 'BD', 'CTS', 'BA', 'WLA', 'AGN', 'ISOC', 'TI', 'BCBA', 'BCWLA', 'BB', 'MIP'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
            } 
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            getVDP() {
                this.arry_vdp = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['PM']['YES'] }, { id: "0", label: this.getLanguage['PM']['NO'] }];
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getSportType(){
                var that = this;
                this.getDataApi(`/api/dd/1188SportTypeOption`,
                    function (d, s) {
                        if (s) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderSportType(d.dropdownlist[i].label);
                            }
                            that.ddSportType = d.dropdownlist
                        }
                    });
            },
            renderSportType(id) {
                return this.getLanguage["SN"][id];
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    //var agi = 0;
                    //if (this.searchAgent) {
                    //    agi = this.searchAgent.split("-")[1];
                    //}
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadLeagueOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddLeagueList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/1188LeagueOption/${searchQuery}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddLeagueList = d.dropdownlist;
                            }
                            else {
                                that.ddLeagueList = [];
                            }

                            callback(null, that.ddLeagueList);
                        });
                }
            },
            loadHomeOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddHomeList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/1188LeagueHomeOption/${searchQuery}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddHomeList = d.dropdownlist;
                            }
                            else {
                                that.ddHomeList = [];
                            }

                            callback(null, that.ddHomeList);
                        });
                }
            },
            loadAwayOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddAwayList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/1188LeagueAwayOption/${searchQuery}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddAwayList = d.dropdownlist;
                            }
                            else {
                                that.ddAwayList = [];
                            }

                            callback(null, that.ddAwayList);
                        });
                }
            },
            selectAgentOptions(value, instanceId) {
                //if (value) {
                //    this.setSearchCriteriaAGI(value);
                //}
                //else {
                //    this.setSearchCriteriaAGI(null);
                //}
                var temp = "";
                for (var x = 0; x < value.length; x++) {
                    if (x != 0) {
                        temp += ",";
                    }
                    var split = value[x].split("-");

                    if (split.length == 2) {
                        temp += split[1];
                    }
                    else {
                        temp += split[0];
                    }
                }
                this.searchAgi = temp;
                this.ddCurrencyList = null;
                this.searchCurrencyId = null;
            },
            loadCurrencyOptions({ action, callback, instanceId }) {
                var that = this;

                if (!this.searchAgi) {
                    this.searchAgi = 0;
                }

                this.getDataApi(`/api/dd/currency/${this.searchAgi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderCurrency(d.dropdownlist[i].label);
                            }
                            that.ddCurrencyList = d.dropdownlist;
                        }
                        else {
                            that.ddCurrencyList = null;
                        }

                        callback();
                    });
            },
            renderCurrency(ISOC) {
                return this.getLanguage['DB'][ISOC];
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getReportList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.getReportList();
            },
            renderEventInfo(eventInfo, provider) {
                return eventInfo;
            },
            renderGameResult(gameResult, provider) {
                if (provider == "AFB1188") {
                    if (gameResult != "") {
                        try {
                            gameResult = gameResult.replace("afb_result", this.getLanguage["WLRPT"]["R"]);
                            gameResult = gameResult.replace("afb_score", this.getLanguage["WLRPT"]["FSC"]);
                            gameResult = gameResult.replace("afb_over", this.getLanguage["AFB1188"]["OV"]);
                            gameResult = gameResult.replace("afb_under", this.getLanguage["AFB1188"]["UN"]);
                            gameResult = gameResult.replace("afb_odd", this.getLanguage["AFB1188"]["ODD"]);
                            gameResult = gameResult.replace("afb_even", this.getLanguage["AFB1188"]["EVEN"]);
                            gameResult = gameResult.replace("afb_draw", this.getLanguage["AFB1188"]["DRAW"]);

                            gameResult = gameResult.replace("afb_win", this.getLanguage["AFB1188"]["WIN"]);

                            gameResult = gameResult.replace(/afb_lastgoal/gi, this.getLanguage["AFB1188"]["LG"]);
                            gameResult = gameResult.replace(/afb_firstgoal/gi, this.getLanguage["AFB1188"]["FG"]);
                            gameResult = gameResult.replace(/afb_nogoal/gi, this.getLanguage["AFB1188"]["NG"]);

                            gameResult = gameResult.replace("afb_dc", this.getLanguage["AFB1188"]["DC"]);
                            gameResult = gameResult.replace("afb_tg", this.getLanguage["AFB1188"]["TG"]);

                            gameResult = gameResult.replace("afb_bd", this.getLanguage["AFB1188"]["BD"]);
                        }
                        catch (ex) {
                            console.log(ex);
                        }
                    }
                }
                return gameResult;
            },

            renderActivityStyle(Activitytype) {
                if (Activitytype == 1) {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
                else if (Activitytype == 2) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else if (Activitytype == 3) {
                    return { 'font-weight': 'bold', color: '#7800b6' };
                }
            },
            searchHomeAway(league, home, away) {
                this.ddDefaultLeagList = [
                    { id: league, label: league }
                ];

                this.ddDefaultHomeList = [
                    { id: home, label: home }
                ];

                this.ddDefaultAwayList = [
                    { id: away, label: away }
                ];

                this.dd_leagueKey++;
                this.dd_homeKey++;
                this.dd_awayKey++;

                this.searchLeague = league;
                this.searchHome = home;
                this.searchAway = away;

                this.getReportList();
            },
            getReportList() {
                this.bool_fullLoading = true;
                var that = this;
                var agentGId = null;
                
                this.searchInfo = '';

                //if (this.searchAgent) {
                //    var agentList = this.searchAgent.split("-");
                //    agentGId = agentList[agentList.length - 1];
                //}

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                //if (agentGId) {
                //    path += "&f.AGI=" + agentGId;
                //}
                if (this.searchAgi) {
                    path += "&f.AGI_csv=" + this.searchAgi;
                }
                if (this.searchUserId) {
                    path += "&f.MID=" + this.searchUserId;
                }

                if (this.searchCurrencyId) {
                    path += "&f.CI=" + this.searchCurrencyId;
                }

                if (this.searchMinAmount || this.searchMinAmount == 0) {
                    path += "&f.A_from=" + this.searchMinAmount;
                }

                if (this.searchMaxAmount || this.searchMaxAmount == 0) {
                    path += "&f.A_to=" + this.searchMaxAmount;
                }

                if (this.searchSportType) {
                    path += "&f.ST=" + this.searchSportType;
                }

                if (this.searchLeague) {
                    path += "&f.LG=" + this.searchLeague;
                    this.searchInfo += 'L: (' + this.searchLeague + ')';
                }

                if (this.searchHome) {
                    path += "&f.HT=" + this.searchHome;
                    this.searchInfo += 'H: (' + this.searchHome + ')';
                }

                if (this.searchAway) {
                    path += "&f.AT=" + this.searchAway;
                    this.searchInfo += 'A: (' + this.searchAway + ')';
                }

                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                    }
                }

                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (this.searchCashOut != null) {
                    path += "&f.CO=" + this.searchCashOut;
                }
                
                if (this.searchRegisterSourceName) {
                    path += "&f.RSN=" + this.searchRegisterSourceName;
                }
                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                this.getDataApi(`/api/reports/AFB1188ReportList?${path}`,
                    function (d, s) {
                        that.repoerIsCrypto = false;
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d && d.D && d.D.Items) {
                                for (var i = 0; i < d.D.Items.length; i++) {
                                    d.D.Items[i].bool_showDetails = false;

                                    if (d.D.Items[i].ICT)
                                        that.repoerIsCrypto = d.D.Items[i].ICT;
                                }
                            }

                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_reportList = d.D.Items;
                            that.resizeTableHead();
                        }
                    });

                this.getDataApi(`/api/reports/totalAFB1188ReportSummary?${path}`,
                    function (d, s) {
                        that.setBetSummaryList(d);
                    });
            },
            CheckWinLoss(WLA, status, otherAmount) {
                if (WLA != 0) {
                    if (otherAmount >= 0 && status == 2) {
                        return "positive-number";
                    }
                    else if (otherAmount < 0 && status == 2) {
                        return "negative-number";
                    }
                }
            },
            setBetSummaryList(data) {
                this.arry_Psl = data;
                this.decimal_gt = 0;
                this.decimal_wlagt = 0;
                if (this.arry_Psl.length != 0) {
                    for (var i = 0; i < this.arry_Psl.length; i++) {
                        this.decimal_gt += this.arry_Psl[i].GT;
                        this.decimal_wlagt += this.arry_Psl[i].WLAGT;
                    }
                }
            },
            getStatus(data) {
                var status = '';
                if (data.RS == 1) {
                    status = this.getLanguage['BETRPT']['SIP'];
                }
                else if (data.RS == 2) {
                    if (data.IC == 1) {
                        status = this.getLanguage['BETRPT']['SC'];
                    }
                    else if (data.BD == '') {
                        status = this.getLanguage['BETRPT']['SPRD'];
                    }
                    else if (data.BD != '') {
                        status = this.getLanguage['BETRPT']['SCP'];
                    }
                    else {
                        status = this.getLanguage['BETRPT']['SE'];
                    }
                }

                return status;
            },
            getGameName(provider, name) {
                var gamename = name;

                if (provider in this.getLanguage && name in this.getLanguage[provider]) {
                    gamename = this.getLanguage[provider][name];
                }

                return gamename;
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getMonthStartDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            //report processing for afb1188
            clickList(data) {
                if (data.PN == "AFB1188") {
                    if (data.ISPAR) {
                        try {
                            data.bool_showDetails = !data.bool_showDetails;
                            this.resizeTableHead();
                        }
                        catch (ex) {
                            console.log(ex);
                        }
                    }
                }
            },
            getGameName1188(name) {
                if (this.reportType == "AFB1188") {
                    if (name == "PAR") {
                        name = this.reportType + "_" + name;
                    }
                    else {
                        return name;
                    }
                }

                var gamename = name;

                if (this.reportType in this.getLanguage && name in this.getLanguage[this.reportType]) {
                    gamename = this.getLanguage[this.reportType][name];
                }

                return gamename;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            saveToExcel() {

                //var agentGId = null;

                //if (this.searchAgent) {
                //    var agentList = this.searchAgent.split("-");
                //    agentGId = agentList[agentList.length - 1];
                //}

                var path = this.getListingParamQuery(1, 5000, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                //if (agentGId) {
                //    path += "&f.AGI=" + agentGId;
                //}

                if (this.searchAgi) {
                    path += "&f.AGI_csv=" + this.searchAgi;
                }

                if (this.searchUserId) {
                    path += "&f.MID=" + this.searchUserId;
                }

                if (this.searchCurrencyId) {
                    path += "&f.CI=" + this.searchCurrencyId;
                }

                if (this.searchMinAmount || this.searchMinAmount == 0) {
                    path += "&f.A_from=" + this.searchMinAmount;
                }

                if (this.searchMaxAmount || this.searchMaxAmount == 0) {
                    path += "&f.A_to=" + this.searchMaxAmount;
                }

                if (this.searchSportType) {
                    path += "&f.ST=" + this.searchSportType;
                }

                if (this.searchLeague) {
                    path += "&f.LG=" + this.searchLeague;
                }

                if (this.searchHome) {
                    path += "&f.HT=" + this.searchHome;
                }

                if (this.searchAway) {
                    path += "&f.AT=" + this.searchAway;
                }

                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                    }
                }
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (this.searchCashOut != null) {
                    path += "&f.CO=" + this.searchCashOut;
                }
                
                if (this.searchRegisterSourceName) {
                    path += "&f.RSN=" + this.searchRegisterSourceName;
                }
                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                window.open('/api/reports/AFB1188ReportList/AFB1188ReportListexcel?' + path, '_blank');
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            renderClassName(header, data) {
                if (header == 'WLA' && data) {
                    return "tableCtnRight " + this.CheckWinLoss(data.WLA, data.RS, data.WLA);
                }else if (header == 'U') {
                    return "kema-eft";
                } else if (header == 'BA' || header == 'BB' || header == 'WLA') {
                    return "tableCtnRight";
                }
            },
            resetColumn(headerName) {
                var that = this;
                if (that.hideBrand) {
                    that.removeDefaultColumn('AGN')
                }
                if (!that.repoerIsCrypto) {
                    that.removeDefaultColumn('BCBA')
                    that.removeDefaultColumn('BCWLA')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS2';
            this.$parent.showActiveMenu = 'R.ABRBM';
            this.arry_cash_out = [
                {
                    id: 1,
                    value: '1',
                    label: this.getLanguage['GL']['YES'],  // Yes option
                },
                {
                    id: 0,
                    value: '0',
                    label: this.getLanguage['CNO']['NO'],  // No option
                }
            ];

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.searchAgent = this.$route.query.agi;
            this.searchUsername = this.$route.query.u;
            this.searchUserId = this.$route.query.i;

            if (this.$route.query.df) {
                this.searchCreatedTS.startDate = this.$route.query.df;
            }
            if (this.searchAgent) {
                this.searchAgent = '3-' + this.searchAgent;
            }
            if (this.searchUserId && this.searchUsername) {
                this.ddDefaultMemberList = [
                    { id: this.searchUserId, label: this.searchUsername }
                ];
            }
            this.getVDP();
            this.getSportType();
            if (this.$route.path != this.$route.fullPath)
                this.getReportList();
        },
        watch: {
            getLanguage() {
                this.getReportList();
                this.getVDP();
                this.getSportType();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/AFBSportsBetReportByMatch`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                if (that.hideBrand) {
                                    that.removeDefaultColumn('AGN')
                                    that.removeColumn('AGN')
                                }
                                if (!that.repoerIsCrypto) {
                                    that.removeDefaultColumn('BCBA')
                                    that.removeDefaultColumn('BCWLA')
                                    that.removeColumn('BCBA')
                                    that.removeColumn('BCWLA')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/AFBSportsBetReportByMatch/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/AFB1188BetReportByMatch.vue